import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiPaymentQueryResponse,
  GetApiPaymentQueryParams,
  GetApiPayment401,
  GetApiPayment403,
} from "../../../types/GetApiPayment";

export function getGetApiPaymentUrl() {
  return `/api/Payment` as const;
}

/**
 * {@link /api/Payment}
 */
export async function getApiPayment(
  params?: GetApiPaymentQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiPaymentQueryResponse,
    ResponseErrorConfig<GetApiPayment401 | GetApiPayment403>,
    unknown
  >({
    method: "GET",
    url: getGetApiPaymentUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
